<template>
  <div>
    <template v-if="bannerCourses.length">
      <CarouselCourse
        :courses="bannerCourses"
        :cardType="3"
        :settings="bannerSettings"
      />
    </template>
    <section v-if="dataFeaturedCourses.length">
      <div class="heading-flex">
        <h2>Course Pilihan</h2>
        <router-link
          @click.native="changeCurrentMenu('Temukan')"
          :to="{ name: 'Temukan', hash: '#featured' }"
          >Lihat Semua</router-link
        >
      </div>
      <CarouselCourse
        :courses="dataFeaturedCourses"
        :cardType="1"
        :settings="course1Settings"
      />
    </section>
    <section v-if="popularCourses.length">
      <div class="heading-flex">
        <h2>Course Populer</h2>
        <router-link
          @click.native="changeCurrentMenu('Temukan')"
          :to="{ name: 'Temukan', query: { type: ['popular'] } }"
          >Lihat Semua</router-link
        >
      </div>
      <CarouselCourse
        :courses="popularCourses"
        :cardType="1"
        :settings="course1Settings"
      />
    </section>
    <section v-if="dataFreeCourses.length">
      <div class="heading-flex">
        <h2>Course Gratis</h2>
        <router-link
          @click.native="changeCurrentMenu('Temukan')"
          :to="{ name: 'Temukan', query: { type: ['free'] } }"
          >Lihat Semua</router-link
        >
      </div>
      <CarouselCourse
        :courses="dataFreeCourses"
        :cardType="1"
        :settings="course1Settings"
      />
    </section>
    <div class="mt-10">
      <router-link
        :to="{ name: 'Bantuan' }"
        class="block md:hidden bg-white text-primary text-center border border-blue-500 font-bold px-5 py-3 focus:outline-none rounded-md w-full"
      >
        Butuh Bantuan?
      </router-link>
    </div>
  </div>
</template>

<script>
const CarouselCourse = () =>
  import('@/components/Shared/CardCourse/TemplateCarousel')

const bannerSettings = {
  initialSlide: 1,
  arrow: false,
  dots: true,
  focusOnSelect: false,
  slidesToShow: 1,
  slideToScroll: 1,
  variableWidth: true,
  infinite: true,
  centerMode: true,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnDotsHover: true,
  pauseOnFocus: true,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        // centerMode: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        variableWidth: false,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
  // centerPadding: '25%',
}
const course1Settings = {
  arrow: false,
  focusOnSelect: false,
  slidesToShow: 1,
  slideToScroll: 1,
  variableWidth: true,
  infinite: true,
}
export default {
  data() {
    return {
      bannerSettings,
      course1Settings,
      dataFreeCourses: [],
      dataFeaturedCourses: [],
      featuredCourses: [],
      popularCourses: [],
      bannerCourses: [],
    }
  },
  components: {
    CarouselCourse,
  },
  methods: {
    changeCurrentMenu(menu) {
      this.$store.commit('SET_STATE', { currentMenu: menu })
    },
    async fetchFreeCourse() {
      try {
        const { data } = await this.$store.dispatch('course/FETCH_FREE_COURSE_DASHBOARD')
        this.dataFreeCourses = data.map(course => {
          return {
            ...course,
            key: course._id,
            title: course.name,
            instructor: course.vendorId
              ? course.vendorId.firstName + ' ' + course.vendorId.lastName
              : '-',
            rating: course.averageRating || 0,
            price: course.price,
            type: course.type,
            reviews: course.countReviews || 0,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async fetchFeaturedCourse() {
      try {
        const { data } = await this.$store.dispatch('course/FETCH_FEATURED_COURSE_DASHBOARD')
        console.log(data)
        this.dataFeaturedCourses = data.map(course => {
          return {
            ...course,
            key: course._id,
            title: course.name,
            instructor: course.vendorId
              ? course.vendorId.firstName + ' ' + course.vendorId.lastName
              : '-',
            rating: course.averageRating || 0,
            price: course.price,
            type: course.type,
            reviews: course.countReviews || 0,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    fetchPopularCourse() {
      this.$store.dispatch('course/FETCH_POPULAR_COURSE_LIMIT').then(res => {
        this.popularCourses = res.map(course => {
          return {
            ...course,
            key: course._id,
            title: course.name,
            type: course.type,
            price: course.price,
            instructor: course.vendor?.firstName + ' ' + course.vendor.lastName,
            rating: course.averageRating || 0,
            reviews: course.countReviews || 0,
          }
        })
      })
    },
    fetchDataBanner() {
      this.$store.dispatch('banner/FETCH_ALL_BANNER').then(res => {
        // console.log('databanner', res)
        this.bannerCourses = res.map(el => {
          return {
            key: el._id,
            title: el.name,
            description: el.description,
            image: el.image,
            url: el.url,
          }
        })
      })
    },
  },
  async created() {
    this.fetchFreeCourse()
    this.fetchFeaturedCourse()
  },
  mounted() {
    this.fetchPopularCourse()
    this.fetchDataBanner()
  },
}
</script>

<style lang="scss">
section {
  margin-top: 30px;
}
.heading-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
